module.exports = __webpack_public_path__ + "img/number_2.62b7eb0d.png";